import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconPhone = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.076 13.35a1.601 1.601 0 00-1.297.07l-2.652 1.35a14.997 14.997 0 01-4.896-4.896l1.351-2.655c.203-.4.23-.867.072-1.288L9.192 2.038A1.6 1.6 0 007.694 1H4.11a3.002 3.002 0 00-2.986 3.27 20.81 20.81 0 003.228 9.124 20.489 20.489 0 006.302 6.3 20.779 20.779 0 009.059 3.22A2.996 2.996 0 0023 19.916v-3.583a1.6 1.6 0 00-1.028-1.495l-3.896-1.487zm-3.532 3.451l2.984-1.518 3.473 1.325v3.312a1 1 0 01-1.09 1.004 18.775 18.775 0 01-8.177-2.913 18.518 18.518 0 01-5.7-5.697 18.797 18.797 0 01-2.919-8.24A1 1 0 014.111 3h3.307L8.72 6.469 7.2 9.456a.998.998 0 00.022.948 16.994 16.994 0 006.375 6.375.999.999 0 00.947.022z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconPhone.displayName = "IconPhone";
